import React, {useEffect, useState} from 'react';
import {Modal, Button, Checkbox, Grid} from 'semantic-ui-react';
import {apiGet, apiPut} from '../../../services/apiClient';
import {toast} from 'react-toastify';
import './payerTabSettingsModal.scss';

const FIELD_GROUPS = [
    {key: 'payer', title: 'Плательщик'},
    {key: 'costCenter', title: 'Кост'},
    {key: 'parcelCustomer', title: 'Заказчик'}
];

const emptyGroup = () => ({
    isVisible: false,
    canEdit: false,
    isRequired: false
});

const emptySettings = () => ({
    isVisible: false,
    payer: emptyGroup(),
    costCenter: emptyGroup(),
    parcelCustomer: emptyGroup()
});

export function normalizePayerTabSettings(raw) {
    const next = Object.assign(emptySettings(), raw || {});
    FIELD_GROUPS.forEach(({key}) => {
        const g = Object.assign(emptyGroup(), next[key] || {});
        const visible = !!(g.canEdit || g.isRequired || g.isVisible);
        next[key] = {
            isVisible: visible,
            canEdit: visible ? !!g.canEdit : false,
            isRequired: visible ? !!g.isRequired : false
        };
    });
    next.isVisible = FIELD_GROUPS.some(({key}) => next[key].isVisible);
    return next;
}

const PayerTabSettingsModal = ({open, companyId, onClose}) => {
    const [settings, setSettings] = useState(emptySettings());
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!open || !companyId) {
            return;
        }
        setLoading(true);
        apiGet(`admin/companies/${companyId}/payerTabSettings`)
            .then(data => setSettings(normalizePayerTabSettings(data || {})))
            .catch(err => toast.error((err && (err.error || err.Error)) || 'Не удалось загрузить настройки'))
            .finally(() => setLoading(false));
    }, [open, companyId]);

    const toggle = (groupKey, field, value) => {
        setSettings(prev => {
            const patch = {};
            patch[groupKey] = Object.assign({}, prev[groupKey], {[field]: value});
            return normalizePayerTabSettings(Object.assign({}, prev, patch));
        });
    };

    const save = () => {
        const payload = normalizePayerTabSettings(settings);
        setSaving(true);
        apiPut(`admin/companies/${companyId}/payerTabSettings`, payload)
            .then(() => {
                toast.success('Настройки сохранены');
                onClose(true);
            })
            .catch(err => toast.error((err && (err.error || err.Error)) || 'Не удалось сохранить настройки'))
            .finally(() => setSaving(false));
    };

    const renderCard = (group) => {
        const g = settings[group.key] || emptyGroup();
        return (
            <div className="payer-tab-settings-modal__card" key={group.key}>
                <div className="payer-tab-settings-modal__card-title">{group.title}</div>
                <div className="payer-tab-settings-modal__options">
                    <Checkbox
                        className="payer-tab-settings-modal__option"
                        label="Видимо"
                        checked={!!g.isVisible}
                        onChange={(e, {checked}) => toggle(group.key, 'isVisible', checked)}
                    />
                    <Checkbox
                        className="payer-tab-settings-modal__option"
                        label="Редактируемо"
                        checked={!!g.canEdit}
                        disabled={!g.isVisible}
                        onChange={(e, {checked}) => toggle(group.key, 'canEdit', checked)}
                    />
                    <Checkbox
                        className="payer-tab-settings-modal__option"
                        label="Обязательно"
                        checked={!!g.isRequired}
                        disabled={!g.isVisible}
                        onChange={(e, {checked}) => toggle(group.key, 'isRequired', checked)}
                    />
                </div>
            </div>
        );
    };

    return (
        <Modal open={open} onClose={() => onClose(false)} size="small" className="payer-tab-settings-modal">
            <Modal.Header>Редактирование вкладки «Плательщик»</Modal.Header>
            <Modal.Content scrolling>
                {loading ? (
                    <div className="payer-tab-settings-modal__loading">Загрузка...</div>
                ) : (
                    <div>
                        <div className="payer-tab-settings-modal__tab-hint">
                            Вкладка «Плательщик» на форме посылки будет видна, если включено хотя бы одно поле ниже.
                        </div>
                        <Grid columns={1} className="payer-tab-settings-modal__grid">
                            {FIELD_GROUPS.map(group => (
                                <Grid.Column key={group.key}>
                                    {renderCard(group)}
                                </Grid.Column>
                            ))}
                        </Grid>
                    </div>
                )}
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={() => onClose(false)} disabled={saving}>Закрыть</Button>
                <Button primary onClick={save} loading={saving} disabled={loading}>Сохранить</Button>
            </Modal.Actions>
        </Modal>
    );
};

export default PayerTabSettingsModal;



// WEBPACK FOOTER //
// ./App/pages/admin/companies/payerTabSettingsModal.jsx